module.exports = __webpack_public_path__ + "0d72931642eb197cc5ac383e67d0efab.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/13.png
// module id = 297
// module chunks = 0